<div class="profile-container" *ngIf="isCardVisible || !isMobile">
    <!-- Profile Header Card -->
    <div class="card profile-header">
        <div class="profile-avatar">
            <img src={{this.profileImageBase64}} alt="Profile" class="profile-image" />
            <div class="edit-avatar">
                <a [routerLink]="'/parent/myprofile'" class="edit-btn">
                    <i class="bi bi-pencil"></i>
                </a>
            </div>
        </div>
        <h2 class="profile-name">{{userDetail?.firstName}} {{userDetail?.lastName}}</h2>
        <p class="profile-role">{{ rolesString }}</p>
    </div>
    <div class="my-kids-container" *ngIf="isCardVisible">
        <!-- Header -->
        <div class="header-card">
            <h2>My Kids</h2>
            <p>Manage and view your children's profiles.</p>
        </div>
        <div class="kids-list">
            <div class="year-selector-container">
                <label for="year-selector" class="year-selector-label">Select Year:</label>
                <select id="year-selector" [(ngModel)]="selectedYear" (change)="onYearChange()" class="year-selector-dropdown">
                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                </select>
            </div>
            <li class="kid-card" *ngFor="let kid of kids" [class.active]="activeKid === kid.name">
                <div class="kid-avatar">
                    <img [src]="kid.avatar" alt="Avatar" />
                </div>
                <div class="kid-info">
                    <h3>
                        <a (click)="onKidNameClick(kid)" class="kid-name">
                            {{ kid.name }}
                        </a>
                    </h3>
                    <p>Year: {{ kid.grade }}</p>
                </div>
            </li>
        </div>
    </div>
</div>